module.exports = __webpack_public_path__ + "static/img/DSC_0775.2a2b657.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DSC_0775.jpeg
// module id = 309
// module chunks = 2